import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { di } from '../../state/inversify.config';
import { LoginDomainService } from '../../pages/login/loginDomainService';
import styles from './syncStatusIndicator.module.scss';

export const SyncStatusIndicator = () => {
  const loginDomainService = di.get<LoginDomainService>(LoginDomainService);
  const { t } = useTranslation();
  const theme = useTheme();

  const isSyncing = loginDomainService.useIsSyncingSelector();

  return isSyncing ? (
    <div className={styles.indicatorContainer}>
      <Typography sx={{ color: theme.palette.text.primary }}>
        {t('SYNCING')}
      </Typography>
      <div className={styles.indicatorDot}>&nbsp;</div>
    </div>
  ) : null;
};
